import Repository from "../Repository";

const Create = "create";
const getTopicByChapterId = "getTopicByChapterId";
const Delete = "delete";
export default {
  CreateTopic(payload) {
    return Repository.post(transformRoute(Create), payload);
  },
  GetTopicByTopicId(payload) {
    return Repository.post(transformRoute(getTopicByChapterId), payload);
  },
  deleteTopic(payload) {
    return Repository.post(transformRoute(Delete), payload);
  },
};

const transformRoute = (route) => {
  return `eLearning/topic/${route}`;
};
